import React from 'react';
import BeaconChartWithLegend from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { getEntityDisplayNames } from '../Ineligible/utils';
import { useAppSelector } from 'src/utils/Hooks';

import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useEntityPhrasing } from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import NoDataPlaceHolder, {
  NoDataIcon
} from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import {
  BEACON_CHART_SPACING,
  BEACON_KEY_METRIC_CARD_SPACING
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { NewBeaconFileIcon } from 'src/components/SvgIcons';

import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import AdvertisingSummaryMetricsCards from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdMetric/AdvertisingSummaryMetricsCards';
import SelectedAdMetricChart from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdMetric/SelectedAdMetricChart';
import AdDailySpendBarChart from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdMetric/AdDailySpendBarChart';

import AdMetricGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdMetric/AdMetricGrid';
import AdMetricBarChart from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdMetric/AdMetricBarChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { checkInstacartRetailer } from 'src/utils/app';

export const EntityNoDataPlaceHolder = (
  <Flex marginTop="71px" alignItems="center" justifyContent="center">
    <NoDataPlaceHolder
      title="Data currently unavailable"
      description="There is currently no data matching your selected criteria. Please try another query to view insights."
      icon={<NoDataIcon icon={<NewBeaconFileIcon />} />}
    />
  </Flex>
);

/**
 * Review tab, Summary page
 */
const AdMetric = () => {
  const entityType = useMainEntityType();
  let entityPhrase = useEntityPhrasing({ titleOnly: true });

  if (entityType === 'product') {
    entityPhrase = '';
  }

  const retailerSku = useAppSelector((state) => state?.entityService?.mainEntity?.retailerSku);
  const adjustedEntityPhrase = entityType === 'adCampaign' ? 'this campaign' : entityPhrase;
  const adjustedEntityTypeSuffix =
    entityType === 'adCampaign' ? '' : ` ${getEntityDisplayNames(entityType, retailerSku)}`;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <Flex flexDirection="column" gap={BEACON_KEY_METRIC_CARD_SPACING}>
          <BeaconChartWithLegend
            title="Key Metrics"
            showExportMenu={false}
            includeSummaryInfo={false}
            subtitle={
              <BeaconSubtitleContainer>
                <Text variant="body1">{`The metrics display the advertising performance summary for ${adjustedEntityPhrase}${adjustedEntityTypeSuffix}.`}</Text>
              </BeaconSubtitleContainer>
            }
          >
            <AdvertisingSummaryMetricsCards />
          </BeaconChartWithLegend>
        </Flex>
        <SelectedAdMetricChart />
        {['client', 'adEntity', 'adPortfolio', 'adCampaign'].includes(entityType) && !checkInstacartRetailer() && (
          <AdDailySpendBarChart />
        )}
        <AdMetricBarChart />
        <AdMetricGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default AdMetric;
